<template>
  <div class="col-12">
    <SearchCard
      ref="allTicketSearch"
      :filterCatch="true"
      :title="$lang.ticketLang.ticket_list"
      :url="url"
      :html="false"
      :parentParams="parentParams"
      :allowFields="$lang.ticketLang.allTicketSearch"
      :extraButtons="extraButtons"
      :hasUploadExcel="true"
      :uploadExcelTooltip="$lang.ticketLang.all_ticket_upload_excel_form_title"
      @handleUploadExcel="showImportExcelModal"
      @updatePermissions="updatePermissions"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          class="py-1 border-bottom d-md-flex d-block align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <span
              v-b-tooltip.hover
              :title="
                pathOr(
                  null,
                  ['message_count'],
                  $lang.ticketLang.allTicketSearch
                )
              "
              class="badge badge_ticket badge-danger badge-pill"
              >{{ item.message_count }}</span
            >
            <span
              class="mr-1 fs_1_3rem w_h_35 border bg-light rounded-circle-sms d-flex align-items-center justify-content-center"
              v-b-tooltip.hover
              :title="``"
            >
              <i class="fas fa-sms text-success"></i>
            </span>
            <b
              class="px-1 fs_1rem"
              v-text="`${item.ticket_code} - ${item.ticket_subject}`"
            />
          </div>

          <div
            class="text-muted d-md-block d-flex align-items-center justify-content-between"
          >
            <div
              v-b-tooltip
              title="ثبت کننده"
              v-if="pathOr(null, ['created_by'], item)"
            >
              <i class="fas fa-user mr-1" />
              <span v-text="pathOr('', ['created_by'], item)" />
            </div>
            <div
              v-b-tooltip
              :title="
                pathOr(
                  null,
                  ['created_at.jalali'],
                  $lang.ticketLang.allTicketSearch
                )
              "
            >
              <i class="fas fa-clock mr-1" />
              <span v-text="pathOr('', ['created_at', 'jalali'], item)" />
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="auto" class="px-0">
          <div
            :class="`bg-${changeColorRow(item)} border-delay p-2`"
            v-b-tooltip.hover
            :title="
              pathOr(
                null,
                ['ticket_hour_delay'],
                $lang.ticketLang.allTicketSearch
              )
            "
            class="d-flex justify-content-center align-items-center"
          >
            <b v-text="item.ticket_hour_delay" />
          </div>
        </b-col>
        <b-col cols="12" md="2" class="text-center my-2">
          <b-img-lazy
            fluid
            thumbnail
            :onerror="$config.images.onerrorDefaultImg"
            :src="
              item.user &&
              item.user.images_kind &&
              item.user.images_kind.find((x) => x.type === `thumb`)
                ? item.user.images_kind.find((x) => x.type === `thumb`).address
                : `${$config.images.tinyLogo}`
            "
            class="bg-white"
            width="150"
          />
        </b-col>
        <b-col cols="12" md="" class="my-2">
          <b-row>
            <b-col cols="12" md="12" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="'کاربر'" />:
              <ProfileBoxPopupWrapper
                :data="item.user"
                deskTopPopupClass="top-230"
                nameClass="color-complementary"
              />
            </b-col>
            <b-col cols="12" md="12" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="'نام کاربری'" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['user', 'username'], item)"
              />
            </b-col>
            <b-col cols="12" md="12" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="'شماره همراه'" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['user', 'mobile'], item)"
              />
            </b-col>
            <b-col cols="12" md="12" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="'شماره پرونده'" />:
              <a
                :href="goToParvandeh(item)"
                target="_blank"
                v-text="pathOr('', ['parvandeh', 'parvandeh_number'], item)"
              />
            </b-col>
            <b-col cols="12" md="12" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="'نام دوره'" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['parvandeh', 'term', 'caption'], item)"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="" class="my-2">
          <b-row>
            <b-col cols="12" md="8" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="'وضعیت درخواست'" />:
              <b-badge
                href="#"
                variant="primary"
                v-text="pathOr('', ['ticket_status_id', 'caption'], item)"
              />
            </b-col>
            <b-col cols="12" md="8" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="'زمان آخرین بررسی'" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['updated_at', 'jalali'], item)"
              />
            </b-col>
            <b-col
              cols="12"
              md="8"
              class="py-1 position-relative"
              v-if="item.user.name !== item.last_reviewer"
            >
              <i class="far fa-check-circle mr-1" />
              <b v-text="'آخرین بررسی کننده'" />:
              <span
                class="cursor_pointer text-muted"
                :id="`popover-target-${item.code}`"
                v-text="item.last_reviewer"
              />
              <b-tooltip
                :target="`popover-target-${item.code}`"
                triggers="click"
              >
                <b-img-lazy
                  :src="
                    item.last_reviewer_img_kind &&
                    item.last_reviewer_img_kind.find((x) => x.type === `thumb`)
                      ? item.last_reviewer_img_kind.find(
                          (x) => x.type === `thumb`
                        ).address
                      : `${$config.images.tinyLogo}`
                  "
                  class="bg-white img-standard"
                  width="150"
                />
              </b-tooltip>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="12" class="pb-1 pt-1 border-gray-top">
          <b-row align-v="center" align-h="between" class="w-100 m-0">
            <b-col cols="12" md="auto" class="px-0">
              <div>
                <span class="mr-2"
                  ><i class="fas fa-university text-secondary"></i></span
                >{{
                  pathOr(
                    null,
                    ["ticket_unit_id.caption"],
                    $lang.ticketLang.allTicketSearch
                  )
                }}
                : {{ item.ticket_unit_id.caption }}
              </div>
            </b-col>
            <b-col cols="12" md="" class="text-right px-0">
              <b-button
                @click="editTikect(item)"
                variant="outline-success"
                size="sm"
              >
                <i class="fas fa-edit fa-lg mr-1" />
                <b v-text="$lang.edit" />
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </SearchCard>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="importExcelModal"
      :title="$lang.ticketLang.upload_excel_file"
      size="lg"
      hide-header
      hide-footer
    >
      <b-card>
        <div slot="header">
          {{ $lang.ticketLang.all_ticket_upload_excel_form_title }}
        </div>
        <b-row>
          <b-col cols="12" md="12">
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="`${$lang.ticketLang.subject}: `"
                :rules="$v.ticketSubject.$params"
              />
              <b-form-input
                v-model="$v.ticketSubject.$model"
                type="text"
                autocomplete="off"
                :state="
                  $v.ticketSubject.$dirty ? !$v.ticketSubject.$error : null
                "
                @input="submitImportExcel"
              />
              <b-form-invalid-feedback
                :state="
                  $v.ticketSubject.$dirty ? !$v.ticketSubject.$error : null
                "
              >
                <div v-if="!$v.ticketSubject.required">
                  {{ $lang.error_required | replace($lang.ticketLang.subject) }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="`${$lang.ticketLang.ticket_unit}: `"
                :rules="$v.ticketUnitSelected.$params"
              />
              <selectFind
                :options="ticketUnitOptions"
                v-model="$v.ticketUnitSelected.$model"
                label="text"
                :isValid="
                  $v.ticketUnitSelected.$dirty
                    ? !$v.ticketUnitSelected.$error
                    : null
                "
                @input="submitImportExcel"
              />
              <b-form-invalid-feedback
                :state="
                  $v.ticketUnitSelected.$dirty
                    ? !$v.ticketUnitSelected.$error
                    : null
                "
              >
                <div v-if="!$v.ticketUnitSelected.required">
                  {{
                    $lang.error_required | replace($lang.ticketLang.ticket_unit)
                  }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" class="mb-3">
            <b-form-group label-cols="5">
              <requiredComponent
                slot="label"
                :label="`${$lang.ticketLang.ticket_send_sms}: `"
                :rules="$v.hasSendSms.$params"
              />
              <b-form-checkbox
                v-model="hasSendSms"
                name="check-button"
                switch
                class="mt-2"
              >
                <b v-if="hasSendSms" v-text="'بله'" class="text-success" />
                <b v-else v-text="'خیر'" class="text-danger" />
              </b-form-checkbox>
              <b-form-invalid-feedback
                :state="$v.hasSendSms.$dirty ? !$v.hasSendSms.$error : null"
              >
                <div v-if="!$v.hasSendSms.required">
                  {{
                    $lang.error_required
                      | replace($lang.ticketLang.ticket_send_sms)
                  }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <ShowCardUpload
          :url="uploadExcelUrl"
          :showAlert="exampleFileLink"
          :hasAppendData="true"
          :appendData="appendData"
          :isValidAppendData="isValidAppendData"
          @getItems="getData"
          @submit="submitImportExcel"
          @closeModal="showImportExcelModal(false)"
        />
      </b-card>
    </b-modal>
    <b-modal v-model="isModal" size="md" hide-header hide-footer>
      <groupEnd @close="closeModal" @getItems="getItems" />
    </b-modal>
  </div>
</template>

<script>
import SearchCard from "@/components/base/searchCard";
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import { pathOr, includes } from "ramda";
import groupEnd from "./groupEnd";
import { required } from "vuelidate/lib/validators";
import { renderEumOptions, isAdmin, generateApiUrl } from "@/shared/utils";
import { ProfileBoxPopupWrapper } from "@/components/re-design";

export default {
  name: "all-ticket-search",
  components: {
    SearchCard,
    ShowCardUpload,
    groupEnd,
    ProfileBoxPopupWrapper,
  },
  validations: {
    ticketSubject: { required },
    ticketUnitSelected: { required },
    hasSendSms: { required },
  },
  data() {
    return {
      isModal: false,
      importExcelModal: false,
      ticketSubject: null,
      ticketUnitSelected: null,
      hasSendSms: false,
      isValidAppendData: false,
      permissions: [],
    };
  },
  computed: {
    parentParams() {
      const user_code = pathOr(null, ["user_code"], this.$route.query);
      return user_code ? { user_code } : {};
    },
    url() {
      return generateApiUrl(["ticket", "all_ticket"]);
    },
    uploadExcelUrl() {
      return generateApiUrl(["ticket", "import_ticket"]);
    },
    exampleFileLink() {
      const link = `${generateApiUrl(["resources", "upload_folder"], [], {}, [
        "server_url",
      ])}/import_ticket.xlsx`;
      return `<div class='text-center font-weight-bold'><a href='${link}'>جهت دانلود فایل نمونه کلیک کنید</a></div>`;
    },
    appendData() {
      return {
        ticket_subject: this.ticketSubject,
        ticket_unit_id: pathOr(null, ["value"], this.ticketUnitSelected),
        send_message: this.hasSendSms ? 1 : 0,
      };
    },
    ticketUnitOptions() {
      return renderEumOptions("ticket_unit");
    },
    extraButtons() {
      return [
        {
          name: "startOperatorTicket",
          condition: isAdmin(this.permissions, ["admin"]),
          title: this.$lang.ticketLang.start_operator_ticket,
          click: this.goToOperatorAddTicket,
          iconName: "email-send-outline",
        },
        {
          name: "groupEndRequest",
          condition: isAdmin(this.permissions),
          title: this.$lang.ticketLang.group_end_request,
          click: this.openModal,
          iconName: "email-remove-outline",
        },
      ];
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    openModal() {
      this.isModal = true;
    },
    closeModal() {
      this.isModal = false;
    },
    getItems() {
      this.$refs.allTicketSearch.getItems();
      this.isModal = false;
    },
    changeColorRow(item) {
      if (item.ticket_hour_delay > 48 && item.ticket_status_id.id == 1) {
        return "danger";
      } else if (
        item.ticket_hour_delay > 24 &&
        item.ticket_hour_delay < 48 &&
        item.ticket_status_id.id == 1
      ) {
        return "warning";
      } else {
        return "";
      }
    },
    updatePermissions(data) {
      this.permissions = data;
    },
    getData() {
      this.$refs.allTicketSearch.getItems();
    },
    AddTikect() {
      this.$router.push({
        name: "addTicket",
      });
    },
    editTikect(item) {
      const routeData = this.$router.resolve({
        name: "edit_all_ticket",
        params: {
          code: item.code,
        },
      });
      window.open(routeData.href, "_blank");
    },
    goToOperatorAddTicket() {
      const routeData = this.$router.resolve({
        name: "operator_add_ticket",
      });
      window.open(routeData.href, "_blank");
    },
    goToParvandeh(item) {
      const parvandeh_number = pathOr(
        null,
        ["parvandeh", "parvandeh_number"],
        item
      );
      const routerData = this.$router.resolve({
        name: "parvandeh_by_number",
        params: { parvandeh_number },
      });
      return routerData.href;
    },
    showImportExcelModal(state = true) {
      if (state) {
        this.$v.$reset();
        this.ticketSubject = null;
        this.ticketUnitSelected = null;
        this.hasSendSms = false;
        this.isValidAppendData = false;
      }
      this.importExcelModal = state;
    },
    submitImportExcel() {
      this.$v.$touch();
      this.isValidAppendData = !this.$v.$anyError;
    },
  },
};
</script>

<style>
.table-danger {
  background-color: #ff5d5d !important;
}

.table-warning {
  background-color: #ffd450 !important;
}

.rounded-circle-sms {
  border-radius: 60%;
  width: 35px;
  height: 35px;
}
.badge_ticket {
  right: 1%;
  top: 2%;
  position: absolute !important;
}
.border-delay {
  border-left: 1px solid lightgray;
  height: 100%;
}
.border-gray-top {
  border-top: 1px solid lightgray;
}
.img-standard {
  min-width: 150px;
  min-height: 100px;
  margin: auto;
}
</style>
